<template>
  <asc-page-loading-indicator
    :loading="isAscentiaAnalyticsLoading && !apiPageFailure.length"
  >
    <v-container fluid class="asc-ascentia-analytics-list-container">
      <v-row>
        <v-col cols="12" sm="12">
          <asc-page-header>
            <template #pageTitle>
              <asc-page-title title="">
                Ascentia<sup>&reg;</sup> Analytics
              </asc-page-title>
            </template>
          </asc-page-header>
        </v-col>
      </v-row>
      <asc-ascentia-analytics-list-template
        :values="ascentiaAnalyticsWithAlertTypes"
        :user-airlines="mappedUserAirlines"
        @onAnalyticDetailsView="handleAnalyticDetailsView"
      />
    </v-container>
    <asc-analytic-details-dialog
      :show-dialog="showAnalyticDetailsDialog"
      :data="analyticDetails"
      :saving="savingCustomMxRecEntry"
      :saved-custom-entry="customMxRecEntry"
      @onAnalyticDetailsDialogClose="handleAnalyticDetailsDialogClose"
      @onAnalyticDetailsSave="handleAnalyticDetailsSave"
    />
  </asc-page-loading-indicator>
</template>
<script>
import {
  ANALYTIC_MODULE_CONSTS as AMC,
  GLOBAL_FILTER_CONSTS as GF,
  USER_CONSTS as UC,
} from '@/stores/consts'
import { mapActions, mapGetters, mapState } from 'vuex'
import AscPageHeader from '../../../atoms/AscPageHeader'
import AscPageTitle from '../../../atoms/AscPageTitle'
import AscAnalyticDetailsDialog from '../../../molecules/AscAnalyticDetailsDialog.vue'
import AscPageLoadingIndicator from '../../../molecules/AscPageLoadingIndicator'
import { AscAscentiaAnalyticsListTemplate } from '../../../templates'

export default {
  name: 'AscAscentiaAnalyticsListContainer',

  components: {
    AscPageTitle,
    AscPageHeader,
    AscPageLoadingIndicator,
    AscAnalyticDetailsDialog,
    AscAscentiaAnalyticsListTemplate,
  },

  data() {
    return {
      isAscentiaAnalyticsLoading: false,
      showAnalyticDetailsDialog: false,
      dialogTitle: '',
      analyticDetails: null,
    }
  },

  computed: {
    ...mapGetters(UC.NAMESPACE, ['mappedUserAirlines']),
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(GF.NAMESPACE, ['globalFilter']),
    ...mapState(AMC.NAMESPACE, [
      'ascentiaAnalyticsWithAlertTypes',
      'analyticModule',
      'customMxRecEntry',
      'savingCustomMxRecEntry',
    ]),
  },

  watch: {
    globalFilter: {
      deep: true,
      async handler() {
        this.getAscentiaAnalyticsWithAlertTypesList()
      },
    },
  },

  created() {
    this.getAscentiaAnalyticsWithAlertTypesList()
  },

  methods: {
    ...mapActions(AMC.NAMESPACE, [
      AMC.GET_ASCENTIA_ANALYTICS_WITH_ALERT_TYPES,
      AMC.GET_ANALYTIC_MODULE,
      AMC.SAVE_CUSTOM_MX_REC_ENTRY,
      AMC.GET_CUSTOM_MX_REC_ENTRY,
      AMC.SAVE_CUSTOM_MX_REC_ENTRY,
    ]),

    async getAscentiaAnalyticsWithAlertTypesList() {
      this.isAscentiaAnalyticsLoading = true
      await this[AMC.GET_ASCENTIA_ANALYTICS_WITH_ALERT_TYPES]()
      this.isAscentiaAnalyticsLoading = false
    },

    async handleAnalyticDetailsView(data) {
      this.isAscentiaAnalyticsLoading = true
      await this[AMC.GET_ANALYTIC_MODULE]({ id: data.id, isAdmin: true })

      this.analyticDetails = {
        ...data,
        description: this.analyticModule.description,
        defaultMxRecEntry: {
          mxRecTitle: this.analyticModule.mxRecTitle,
          mxRecDetails: this.analyticModule.mxRecDetails,
        },
      }

      // If custom recommendation
      if (data.isAirlineAnalyticRecommendation) {
        await this[AMC.GET_CUSTOM_MX_REC_ENTRY]({
          airlineId: data.airlineId,
          analyticModuleId: data.id,
        })
      }

      this.isAscentiaAnalyticsLoading = false
      this.showAnalyticDetailsDialog = true
    },

    handleAnalyticDetailsDialogClose() {
      this.showAnalyticDetailsDialog = false
      this.analyticDetails = null
    },

    async handleAnalyticDetailsSave(data) {
      await this[AMC.SAVE_CUSTOM_MX_REC_ENTRY](data)
    },
  },
}
</script>
